import React, {useState, useEffect, useContext} from "react";
import OtpVerificationSettingsPopup from "../ResetPasswordPopup/OtpVerificationPopups";
import ResetPasswordSettingsPopup from "../ResetPasswordPopup/ResetPassword";
import CreateNewPasswordSettingsPopup from "../ResetPasswordPopup/CreateNewPasswordPopup";
import ResetPasswordSettingsSuccessPopup from "../ResetPasswordPopup/ResetpasswordSuccess";
import { validatePassword } from "../../../../Components/ReuseableFunctions/ValidationFunctions";
import ReuseablePopup from "../../../../Components/ReuseablePopups/ReuseablePopup";
import { signOut } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { auth, provider } from "../../../LoginAndRegister/Components/UserSigning/Components/LeftSide/ContinueWIth/config";
import { SocketContext } from "../../../../App";
import { GetLocalStorage } from "../../../../Helpers/LocalStorage/LocalStorage";
import { LogOut } from "../../../../Actions/UserA";

const InstituteAccountSecurity= ({UserId, Email}) => {
    const Border = "border-[#E2E2E2] border-[1px] border-solid";

    const socket = useContext(SocketContext);
    const Dispatch = useDispatch();

    const [userEmail, setUserEmail] = useState(Email || "Johndoe@gmail.com");
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [passwordValidationError, setPasswordValidationError] = useState("");
    const [bothPasswordError, setBothPasswordError] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [resetPasswordshowPopup, setResetPasswordShowPopup] = useState(false);
    const [otpVerificationShowPopup, setOtpVerificationShowPopup] = useState(false);
    const [createNewPasswordShowPopup, setCreateNewPasswordShowPopup] = useState(false);
    const [passwordResetSuccessShowPopup, setPasswordResetSuccessShowPopup] = useState(false);

    const validateCurrentPassword = async () => {
        try {
            const response = await fetch("/api/settings/validate-password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ currentPassword, UserId }),
            });

            const result = await response.json();

            if (response.ok) {
                setPasswordError("");
            } else {
                setPasswordError(result.message || "Current password is incorrect. ");
            }
        } catch (error) {
            setPasswordError("An error occurred. Please try again.");
        }
    };

    const handleNewPasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);
        const errors = validatePassword(value);
        setPasswordValidationError(errors);
      };

    const matchBothPasswords = async () => {
        // Validate new password and confirm password match
        setBothPasswordError("")
        if (newPassword !== confirmPassword) {
            setBothPasswordError("New Password and Confirm Password do not match.");
            return;
        }
    };

    const handleChangePassword = async () => {
        // Reset messages
        setErrorMessage("");
        setSuccessMessage("");

        console.log("Inputs:", {
            currentPassword,
            newPassword,
            confirmPassword,
            UserId,
            userEmail,
            passwordError,
            passwordValidationError
          });
          

        // Check for empty fields
        if (!currentPassword || !newPassword || !confirmPassword) {
            if (!currentPassword) {
            setErrorMessage("Please enter your current password.");
            } else if (!newPassword) {
            setErrorMessage("Please enter a new password.");
            } else if (!confirmPassword) {
            setErrorMessage("Please confirm your new password.");
            }
            return;
        }

        // Validation checks before sending the request
        if (
            passwordError ||
            (Array.isArray(passwordValidationError) && passwordValidationError.length > 0) ||
            (typeof passwordValidationError === "string" && passwordValidationError.trim() !== "") ||
            newPassword !== confirmPassword
          ) {
            if (passwordError) {
              setErrorMessage(passwordError);
            } else if (Array.isArray(passwordValidationError) && passwordValidationError.length > 0) {
              setErrorMessage(passwordValidationError[0]); // show first error in array
            } else if (typeof passwordValidationError === "string" && passwordValidationError.trim() !== "") {
              setErrorMessage(passwordValidationError); // show string directly
            } else if (newPassword !== confirmPassword) {
              setErrorMessage("New Password and Confirm Password do not match.");
            }
            return;
          }
          
    
        try {
          // Send data to backend
          const response = await fetch("/api/settings/change-password", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ currentPassword, newPassword, UserId, userEmail }),
          });
    
          const result = await response.json();
    
          if (response.ok) {
            setCurrentPassword("")
            setNewPassword("")
            setConfirmPassword("")
            setShowPopup(true)
          } else {
            setErrorMessage(result.message || "An error occurred.");
          }
        } catch (error) {
          setErrorMessage("An error occurred. Please try again.");
        }
      };

      // Function to check if passwords match
    const validatePasswords = () => {
        if (newPassword !== confirmPassword) {
        return false;
        }
        return true;
    };
    
    // Check if any field is empty
    // const isDisabled = !currentPassword || !newPassword || !confirmPassword || !validatePasswords();

    const isDisabled = 
        !currentPassword ||
        !newPassword ||
        !confirmPassword ||
        passwordError !== "" ||
        passwordValidationError !== "" ||
        !validatePasswords();

    const LogOutUser = async () => {
        signOut(auth, provider)
            .then(() => {
                console.log("Sign-out successful.");
                socket?.emit("offline", { UserId: UserId });
    
                // Dispatch logout action
                Dispatch(LogOut());
    
                // Determine the base URL
                const baseURL =
                    window.location.hostname === "localhost"
                        ? "http://localhost:3000"
                        : "https://vehiclelearning.com/";
    
                // Redirect only if the user is not already on the target page
                if (window.location.href !== baseURL) {
                    setTimeout(() => {
                        window.location.href = baseURL;
                    }, 3000);
                }
            })
            .catch((error) => {
                console.error("Error during sign-out:", error);
            });
        };

   
    return (
        <>
            <div className="w-[95%] flex flex-col justify-center items-center gap-[10px]" >
                <div className="w-[100%] lg:w-[100%] flex flex-col gap-[10px] bg-[#F8FAFA] rounded-[9px] px-[20px] py-[15px]">
                    {/* Email */}
                    <div className="flex flex-col gap-[5px]">
                        <label
                            htmlFor="Email"
                            className="text-[#404040] text-[16px]"
                        >
                            Email
                        </label>
                        <input
                            type="text"
                            id="Email"
                            name="FirstName"
                            readOnly
                            value={userEmail}
                            className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                        />
                    </div>

                    {/* Current Password */}
                    <div className="flex flex-col gap-[5px]">
                        <div className="flex justify-between">
                            <label
                                htmlFor="Current Password"
                                className="text-[#404040] text-[16px]"
                            >
                                Current Password
                            </label>
                            {passwordError && <p className="text-[#ff0000] text-[16px]">{passwordError} 
                            </p>}
                        </div>
                        <input
                            type="password"
                            id="Current Password"
                            placeholder="Enter you current password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            onBlur={validateCurrentPassword} // Validate on blur
                            className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                        />
                    </div>

                    {/* New Password */}
                    <div className="flex flex-col gap-[5px]">
                        <div className="flex justify-between">
                            <label
                                htmlFor="New Password"
                                className="text-[#404040] text-[16px]"
                            >
                                New Password
                            </label>
                            {passwordValidationError && <p className="text-[#ff0000] text-[16px]">{passwordValidationError} </p>}
                            {bothPasswordError && <p className="text-[#ff0000] text-[16px]">{bothPasswordError}</p>}
                        </div>
                        <input
                            type="password"
                            id="New Password"
                            placeholder="Enter you New Password"
                            value={newPassword}
                            // onChange={(e) => setNewPassword(e.target.value)}
                            onChange={handleNewPasswordChange}
                            className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                        />
                    </div>

                    {/* Re Enter New Password */}
                    <div className="flex flex-col gap-[5px]">
                        <label
                            htmlFor="Re Enter New Password"
                            className="text-[#404040] text-[16px]"
                        >
                            Confirm New Password
                        </label>
                        <input
                            type="password"
                            id="Re Enter New Password"
                            placeholder="Enter you new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            onBlur={matchBothPasswords} // Validate on blur
                            className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                        />
                    </div>

                    <p className="text-[22px] text-[#FF5353] cursor-pointer"
                    onClick={()=>setResetPasswordShowPopup(true)}>Reset Password?</p> 
                </div>

                {showPopup && (
                    <ReuseablePopup
                        setShowPopup={setShowPopup}
                        heading="Congratulations !!"
                        text="Your password has been updated successfully."
                        btnText="Sign Out"
                        // onClick={() => setShowPopup(false)} // <-- Add this line
                        onClick={LogOutUser}
                        imageSrc={require("../Assets/SuccessAssets.svg").default} // ✅ Dynamic image source
                        />
                )}

                {resetPasswordshowPopup && (
                    <ResetPasswordSettingsPopup
                        setResetPasswordShowPopup={setResetPasswordShowPopup}
                        userEmail={userEmail}
                        setOtpVerificationShowPopup={setOtpVerificationShowPopup}
                    />
                )}

                {otpVerificationShowPopup && (
                    <OtpVerificationSettingsPopup
                        userEmail={userEmail}
                        setOtpVerificationShowPopup={setOtpVerificationShowPopup}
                        setCreateNewPasswordShowPopup={setCreateNewPasswordShowPopup}
                    />
                )}

                {createNewPasswordShowPopup && (
                    <CreateNewPasswordSettingsPopup
                    setCreateNewPasswordShowPopup={setCreateNewPasswordShowPopup}
                    setPasswordResetSuccessShowPopup={setPasswordResetSuccessShowPopup}
                    UserId={UserId}
                    userEmail={userEmail}
                    />
                )}

                {passwordResetSuccessShowPopup && (
                    <ResetPasswordSettingsSuccessPopup
                        setPasswordResetSuccessShowPopup={setPasswordResetSuccessShowPopup}
                    />
                )}

                {errorMessage && <p className="text-[#ff0000] text-[16px]">{errorMessage} </p>}
                <div className="w-[100%] lg:w-[100%] flex justify-end mt-[10px] pb-[20px]"
                 style={{
                        borderBottom: "1px solid #CECECE"
                    }}>
                    {/* <p className="hidden lg:block text-[18px] ml-[15px] text-[#FF5353] cursor-pointer"
                    onClick={()=>setResetPasswordShowPopup(true)}>Reset Password?</p> */}
                    <button
                    type="button"
                    className={`w-[210px] lg:w-[180px] h-[44px] bg-[#A1A3EF] rounded-[8px] text-[#FFFFFF] text-[18px] lg:text-[20px]`}
                    onClick={handleChangePassword}>
                        Change Password
                    </button>
                </div>

                <div className="w-[100%] lg:w-[100%] flex flex-col gap-[10px] bg-[#F8FAFA] rounded-[9px] px-[20px] py-[15px] mt-[20px]">
                    <div className="w-full flex items-center justify-between pb-[10px]"
                        style={{
                        borderBottom: "1px solid #CECECE"
                        }}>
                        <div className="w-[70%] flex flex-col gap-[15px]">
                            <p className="text-[20px] font-bold text-[#2D2366]">PHONE VERIFICATION</p>
                            <p className="text-[22px] text-[#2D2366]">Edit your phone is verified with VLI. Click Edit to change your phone number</p>
                        </div>

                        <div>
                        <button
                            className={`w-[80px] h-[44px] bg-[#A1A3EF] rounded-[8px] text-[#FFFFFF] text-[18px] lg:text-[20px] cursor-not-allowed`}
                            >
                                Edit
                            </button>
                        </div>
                    </div>

                    <div className="w-full flex items-center justify-between">
                            <div className="w-[70%] flex flex-col gap-[15px]">
                                <p className="text-[20px] font-bold text-[#2D2366]">EMAIL VERIFICATION</p>
                                <p className="text-[22px] text-[#2D2366]">Your e-mail is verified with VLI. Click Edit to change your phone number</p>
                            </div>

                            <div>
                            <button
                                className={`w-[80px] h-[44px] bg-[#A1A3EF] rounded-[8px] text-[#FFFFFF] text-[18px] lg:text-[20px] cursor-not-allowed`}
                                >
                                    Edit
                                </button>
                            </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InstituteAccountSecurity;
